import React, { useContext } from 'react';
import { Switch, Redirect, useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import queryString from 'query-string';

import { UserDetailsContext } from 'context/userDetails';
import { USER_PROFILE_RESOURCES, PAGE_NAMES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';

import GamePlayList from './list';
import TournamentDetails from './tournamentDetails';

const GamePlay: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { userSearchDetails } = useContext(UserDetailsContext);
	const queryParams = _get(history, ['location', 'search']);

	if (_isNil(queryParams) || _isEmpty(queryParams)) {
		if (!_isNil(userSearchDetails) && !_isEmpty(userSearchDetails)) {
			const { selectionType, selectedValue } = userSearchDetails;
			const searchString = `?${queryString.stringify({ [selectionType || '']: selectedValue })}`;
			return <Redirect to={`/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}${searchString}`} />;
		}
		return <Redirect to={`/${PAGE_NAMES.userProfile}/selectUser`} />;
	}

	return (
		<>
			<div className={css({ height: 'calc(100% - 50px)', overflow: 'auto' })}>
				<Switch>
					<AuthorizedRouteV2
						exact
						configPageName={PAGE_NAMES.userProfile}
						configResourceName={USER_PROFILE_RESOURCES.gameplay}
						path={`/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}/details`}
						component={TournamentDetails}
					/>
					<AuthorizedRouteV2
						exact
						configPageName={PAGE_NAMES.userProfile}
						configResourceName={USER_PROFILE_RESOURCES.gameplay}
						path={`/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}`}
						component={GamePlayList}
					/>
					<Redirect
						to={{
							pathname: '/error',
							state: { statusCode: 404, errorMsg: 'Page not found' }
						}}
					/>
				</Switch>
			</div>
		</>
	);
};

export default GamePlay;
